import React from "react";

export default function MoneyBlackIcon() {
	return (
		<svg
			width="35"
			height="35"
			viewBox="0 0 35 35"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M26 22H22.7C22.8657 22.6579 22.955 23.3327 22.966 24.011C22.9631 24.2743 22.8565 24.5258 22.6692 24.711C22.482 24.8962 22.2293 25 21.966 25H13V23H21C21 21.9391 20.5786 20.9217 19.8284 20.1716C19.0783 19.4214 18.0609 19 17 19H13C11.8 17.289 9.305 17 8.1 17H6V25.5L14.192 29.263C15.2 29.7665 16.3631 29.8625 17.44 29.531L30 25.667C30 25.667 29.208 22 26 22Z"
				fill="#1A1C21"
			/>
			<path
				d="M21 6C19.8133 6 18.6533 6.35189 17.6666 7.01118C16.6799 7.67047 15.9109 8.60754 15.4567 9.7039C15.0026 10.8003 14.8838 12.0067 15.1153 13.1705C15.3468 14.3344 15.9182 15.4035 16.7574 16.2426C17.5965 17.0818 18.6656 17.6532 19.8295 17.8847C20.9933 18.1162 22.1997 17.9974 23.2961 17.5433C24.3925 17.0892 25.3295 16.3201 25.9888 15.3334C26.6481 14.3467 27 13.1867 27 12C26.9984 10.4092 26.3658 8.88399 25.2409 7.75911C24.116 6.63424 22.5908 6.00159 21 6V6ZM22 15H20V9H22V15Z"
				fill="#1A1C21"
			/>
		</svg>
	);
}
